//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapMutations, mapActions, mapState } from 'vuex';
export default{
  data: function(){
    return {
      logo:'',
      placeholder:'',
      search_key_arr:[],
      user:{

      },
      loginnav:[
        {url:'/ucenter',name:'我的账户'},
        {url:'/myOrder',name:'我的订单'},
        // {url:'/rentOrder',name:'续约订单'},
        // {url:'/deposit',name:'免押额度'},
        {url:'/invoice',name:'我的发票'},
        // {url:'/logout',name:'退出登录'},
        // {url:'/index',name:'退换货'}
      ],
      message: null,
      catgoodslist:[]
    }
  },
  computed: {
  	...mapState({
  		config: ({ shopro }) => shopro.config,
      userInfo: ({ user }) => user.userInfo,
  		isLogin: ({ user }) => user.isLogin,
      cartNum: ({ cart }) => cart.cartNum,
      cartList: ({ cart }) => cart.cartList
  	}),
  },
  watch:{
    // isLogin(n,o){
    //   this.isLogin = n
    // },
    // userInfo(n){
    //   this.userInfo = n
    // },
    // cartList(n){
    //   this.catgoodslist = n
    // },
    config(newValue, oldValue) {
      this.logo = newValue.shop.logo || ''
      this.placeholder = newValue.share.title || ''
      this.search_key_arr = newValue.shop.search_key_arr || []
    }
  },
  created() {

  },
  mounted() {

  },
  methods:{
    ...mapActions(['changeCartList','getCartList','logout']),
    delcart(id){
      this.changeCartList({ ids: [id], art: 'delete' });

      this.getCartList()
    },
    search(){
      this.jump('productList',{keywords:this.message})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/head.vue